import './style.scss';
import { TranslationService } from '../../../services/translation.service';

function GeneralInformation({ showInformation = true, informationText, className }: { showInformation?: boolean; informationText?: string; className?: string }) {
  return (
    <div aria-live="polite" className={showInformation && className ? className : ''}>
      {showInformation && <div className="alert general-information">{informationText ?? TranslationService.get('triplegselector.searcherrornotrips')} </div>}
    </div>
  );
}

export default GeneralInformation;
